import clsx from "clsx";
import React from "react";

import styles from "./Button.module.css";
import { ButtonProps } from "./Button.types";

/**
 * A button is used to trigger actions based on a user's interaction.
 *
 * A button should only be used to perform an in-page action. If it
 * _looks like_ a Button but navigates to another page instead,
 * for a11y purposes it needs to be a [LinkButton](?path=/docs/components-linkbutton--docs)
 * instead of using `onClick` to navigate.
 */
export const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  disabled,
  appearance = "secondary",
  mode = "default",
  ...rest
}: ButtonProps) => (
  <button
    {...rest}
    data-testid="button"
    disabled={disabled}
    type="button"
    onClick={onClick}
    className={clsx(styles.button, styles[appearance], styles[mode])}
  >
    {label}
  </button>
);
